<div #PanoContainer [style.width.px]="width" [style.height.px]="height" class="panorama"></div>
<svg-icon *ngIf="isLoading" name="spinner-white" class="spinner"></svg-icon>
